"use client";

import { useState } from "react";

export function BiteCompanyLogo({ ticker, companyName, logoSrc }: { ticker: string; companyName: string; logoSrc?: string }) {
  const symbol = ticker.trim().toUpperCase();
  const koreanCode = /^(\d{6})(?:\.(?:KS|KQ))?$/.exec(symbol);
  const src = logoSrc || (koreanCode
    ? `https://ssl.pstatic.net/imgstock/fn/real/logo/stock/Stock${koreanCode[1]}.svg`
    : `https://financialmodelingprep.com/image-stock/${encodeURIComponent(symbol.replace(/\./g, "-"))}.png`);
  const [failedSource, setFailedSource] = useState<string | null>(null);
  return <span className="bite-company-logo">
    {failedSource === src ? <span>{symbol}</span>
      : <img src={src} alt={`${companyName} 로고`} decoding="async" referrerPolicy="no-referrer" onError={() => setFailedSource(src)} />}
  </span>;
}
